// extracted by mini-css-extract-plugin
module.exports = {"Popup":"NewObjectInspector_Popup__fg_8p","Empty":"NewObjectInspector_Empty__QW0mu"};